import feature from './feature.json';
import admin from './admin.json';
import menu from './menu.json';

export const translation = { ...feature, ...admin, ...menu };
export type Translation = typeof translation;
export type TranslationKey = keyof Translation;
